/* Daiko – Univers à onglets : bascule des onglets (clic, clavier, éditeur de thème). */
if (!customElements.get('daiko-univers-tabs')) {
  customElements.define('daiko-univers-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      if (!this.tabs.length) return;
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i, false));
        tab.addEventListener('keydown', (e) => {
          let next = null;
          if (e.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
          if (e.key === 'ArrowLeft') next = (i - 1 + this.tabs.length) % this.tabs.length;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = this.tabs.length - 1;
          if (next !== null) { e.preventDefault(); this.select(next, true); }
        });
      });
      this.onBlockSelect = (e) => {
        if (!e.detail || (e.detail.sectionId && e.detail.sectionId !== this.dataset.sectionId)) return;
        const i = this.tabs.findIndex((t) => t.dataset.blockId === e.detail.blockId);
        if (i > -1) this.select(i, false);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }
    disconnectedCallback() {
      if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }
    select(index, focus) {
      this.tabs.forEach((tab, i) => {
        const on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      const active = this.tabs[index];
      if (focus) active.focus();
      const list = active.parentElement;
      if (list && list.scrollWidth > list.clientWidth) {
        list.scrollTo({ left: active.offsetLeft - (list.clientWidth - active.offsetWidth) / 2, behavior: 'smooth' });
      }
    }
  });
}
